import AuditSummary from './AuditSummary';
import useColumnFilters from 'vl-common/src/hooks/useColumnFilters';
import useTransformColumns from 'vl-common/src/hooks/useTransformColumns';
import { useEffect, useMemo, useRef } from 'react';
import { allAuditCategories, AuditedCategory, getAuditSummaryColumns } from './auditData';
import { useRouter } from 'vl-core/useRouter';
import { usePathname } from 'vl-core/hooks/usePathname';

interface AuditSummaryWrapperProps {
  allowedCategories?: Set<AuditedCategory>;
  user_guid?: string;
  start_date?: string;
  end_date?: string;
}

const getURLSearch = () => {
  const fullUrl = window.location.href;

  return `?${fullUrl.split('?')[1]}`;
};

const AuditSummaryWrapper = ({
  allowedCategories = allAuditCategories,
  user_guid,
  start_date,
  end_date
}: AuditSummaryWrapperProps) => {
  const history = useRouter();
  const queryParamsBefore = useRef(getURLSearch());
  const pathname = usePathname();

  const auditColumns = useMemo(
    () => getAuditSummaryColumns(allAuditCategories, !(start_date || end_date)),
    [end_date, start_date]
  );

  const transformedColumns = useTransformColumns(auditColumns);
  const {
    columns: tableColumns,
    query,
    setQuery,
    handleTableChange
  }: {
    columns: any[];
    query: Record<string, string | number>;
    setQuery: any;
    handleTableChange: any;
  } = useColumnFilters(transformedColumns);

  useEffect(() => {
    return () => {
      history.replace({ search: queryParamsBefore.current });
    };
  }, [history]);

  useEffect(() => {
    return () => {
      const storageKey = JSON.stringify({ tableFilter: { page: pathname, activeTab: 1 } });
      sessionStorage.removeItem(storageKey);
    };
  }, [pathname]);

  return (
    <AuditSummary
      handleTableChange={handleTableChange}
      query={query}
      setQuery={setQuery}
      tableColumns={tableColumns}
      allowedCategories={allowedCategories}
      user_guid={user_guid}
      start_date={start_date}
      end_date={end_date}
    />
  );
};

export default AuditSummaryWrapper;
